import { CommonRequest, CommonResponse, Method, ServiceName } from 'models/common/RestApi';
import { callApi } from 'utils/ApiUtil';
import { Translation } from 'models/admin/Translation';

/** 번역 Text 조회 */
export const getTranslatedText = async (condition) => {
  const request: CommonRequest = {
    method: Method.POST,
    url: `/v1/getTranslate`,
    serviceName: ServiceName.ELM_BE,
    bodyParams: { ...condition },
  };

  const response: CommonResponse<Translation> = await callApi(request);
  return response;
};
